import { memo } from "react";
import { useTranslation } from "react-i18next";

import { setPreferencesViewDescriptionTestId, setPreferencesViewTitleTestId } from "../views/preferences-view.utils";

export const PreferencesHeader = memo(() => {
  const { t } = useTranslation();

  return (
    <div>
      <h1 data-testid={setPreferencesViewTitleTestId()} className="text-3xl font-bold tracking-tight text-balance">
        {t("views.preferences.title")}
      </h1>
      <p data-testid={setPreferencesViewDescriptionTestId()} className="mt-2 text-muted-foreground">
        {t("views.preferences.description")}
      </p>
    </div>
  );
});

PreferencesHeader.displayName = "PreferencesHeader";
